(() => {
  const styleId = 'jsd-follow-on-shop-text';

  function styleFollowButton() {
    let root = document.querySelector('.footer__follow-on-shop shop-login-button');
    let styled = false;

    while (root && root.shadowRoot) {
      root = root.shadowRoot;

      if (root.querySelector('.follow-text') && !root.querySelector(`#${styleId}`)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = '.follow-text { color: #ffffff !important; }';
        root.appendChild(style);
        styled = true;
      }

      root = root.querySelector('shop-follow-button, follow-on-shop-button');
    }

    return styled;
  }

  function initializeFollowButtonColor() {
    if (styleFollowButton()) return;

    let attempts = 0;
    const interval = window.setInterval(() => {
      attempts += 1;
      if (styleFollowButton() || attempts >= 50) window.clearInterval(interval);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeFollowButtonColor, { once: true });
  } else {
    initializeFollowButtonColor();
  }

  document.addEventListener('shopify:section:load', initializeFollowButtonColor);
})();
